import React from "react";

import { i18n } from "../../../translate/i18n";
import {
	formatConnectionChannelLabel,
	formatHubChannelName,
	getChannelIcon,
} from "../connectionChannelsCatalog";

export default function HubChannelPicker({ channels, selectedChannelId, onChange, disabled = false }) {
	return (
		<div className="max-h-72 space-y-2 overflow-y-auto pe-1">
			{channels.map((item) => {
				const isSelected = String(item.id) === String(selectedChannelId);
				const channelTypeLabel = formatConnectionChannelLabel(item.channel, i18n.t.bind(i18n));
				const channelName = formatHubChannelName(item);
				const icon = getChannelIcon(item.channel);

				return (
					<button
						key={item.id}
						type="button"
						disabled={disabled}
						onClick={() => onChange(String(item.id))}
						className={`flex w-full items-center gap-3 rounded-lg border px-3 py-2.5 text-left transition disabled:cursor-not-allowed disabled:opacity-60 ${
							isSelected
								? "border-primary bg-primary/5 shadow-sm dark:border-primary/60 dark:bg-primary/10"
								: "border-default-200 bg-card hover:border-default-300 hover:bg-default-50 dark:border-default-700 dark:bg-default-900 dark:hover:border-default-600 dark:hover:bg-default-800"
						}`}
					>
						<div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-default-100 dark:bg-default-800">
							{icon ? (
								<img src={icon} alt="" className="size-7 object-contain" />
							) : (
								<span className="text-xs font-semibold uppercase text-default-500">
									{channelTypeLabel.slice(0, 2)}
								</span>
							)}
						</div>
						<div className="min-w-0 flex-1">
							<p className="mb-0 text-sm font-semibold text-default-900 dark:text-default-50">
								{channelTypeLabel}
							</p>
							<p className="mb-0 mt-0.5 truncate text-xs text-default-500 dark:text-default-400">
								{channelName}
							</p>
						</div>
						{isSelected && (
							<span className="shrink-0 rounded-full bg-primary px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
								{i18n.t("connections.hubLinkModal.selected")}
							</span>
						)}
					</button>
				);
			})}
		</div>
	);
}
